import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnInit, Renderer2, VERSION } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, tap } from 'rxjs/operators';
import { CommonfileService } from './sag/commonfile.share.service';
import { CommonService } from './services/sagstudioService/common.service';
import { MetaService } from './services/sagstudioService/meta.service';
import { TranslateService } from './services/sagstudioService/translate.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'ngprjdmp';
  angularVersion = VERSION;
  origin = true
 
   
  leftBarMenu: boolean = true;
  rightBarMenu: boolean = false;
  loginForm: any;
   // // FOR RECIEVE MSG FROM PARENT
   @HostListener('window:message', ['$event'])
   async onMessage(e) {  
     // if (e.origin != "http://localhost:54321") { // set your origin
     //   return false;
     // } 
      //  alert(JSON.stringify(e.data))
   
     if(e.data.parentOrigin){
      // localStorage.setItem('parentOrigin',e.data.parentOrigin);
      // localStorage.setItem('previewType',e.data.previewType);
      this.common.previewType.next(e.data.previewType);
     } else {
      // const previewType = localStorage.getItem('previewType') || 'preview';
      this.common.previewType.next("preview");
     }
   }

  constructor(
    private router: Router, 
    private _formBuilder : FormBuilder,
    private activateRoute: ActivatedRoute,
    public translate: TranslateService,
    public common: CommonService, 
    public _shareService: CommonfileService, 
    private meta: MetaService,
    private titleService: Title,
    @Inject(DOCUMENT) private document:Document,
    private renderer: Renderer2 ) {
      this.titleService.setTitle("Amerkila Spices - The Best Quality Spices Since 1985");
      if (typeof window !== "undefined" && window.origin == "http://amerkilspices.com:9291") { // set your origin
        this.origin = false;
      }
  }

  ngOnInit() {
    let self = this;
    this.initLoginForm(); 
   // this.loginBtnClick(); 
    this.translate.getLangList().subscribe((res) => {
      this.translate.languageList = res;
    });
   // this.common.getThemeStatus();
  //  this.router.events
  //  .pipe(
  //     filter(event => event instanceof NavigationEnd),
  //     pluck('urlAfterRedirects'),
  //     tap((data: string)=> {this.meta.updateMeta(data);
  //     })
  // ).subscribe();
  this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((r: any) => r.urlAfterRedirects),
        tap((route: string) => {
          if(route != '/'){
          this.meta.updateMeta(route);
          }
        })).subscribe();

 // this.getMetaInfo();
  }
  
  initLoginForm(){
    this.loginForm= this._formBuilder.group({
      username : ['sag'],
      password  : ['1234']
    })
  }
  setLang(lang: string) {
    this.translate.use(lang).then(() => { });
  }

  loginBtnClick() { 
    const loginValue = {
       "userCode"  : this.loginForm.get('username').value,
        "password" : this.loginForm.get('password').value,
        "lansysInfModel": { "os_name": "Microsoft Windows [Version 10.0.18363.418]", "os_version": "10.0.18363", "sysinfo_ip": "192.168.0.34", "listof_ips": ["192.168.0.34"], "sysinfo_tai": "", "pr_sr": "", "mac_address": "", "status": 200, "system_name": "t138", "sysinfo_osinfo": "t138 - Microsoft Windows [Version 10.0.18363.418] - ia32 - 192.168.0.34" } }
         this.common.login(loginValue)
      .subscribe((res) => { 
        if (res['httpStatus'] == 200) { 
          this.loginGenmaster(res['data']['SagAuthToken']);
          localStorage.setItem('SagAuthToken', res['data']['SagAuthToken']);
          sessionStorage.setItem('loginFormValue' , JSON.stringify(this.loginForm.value));
          sessionStorage.setItem('loginFormValueUserID' , JSON.stringify(res));
          sessionStorage.setItem('tokenData',JSON.stringify(res['data']['SagAuthToken'])) 
        } else {
          alert(res['message'])
        }


      },
      err => { 
       // console.error('err response');
      }
      )
  }

  loginGenmaster(SagAuthToken){
    let tokenObj = { token: SagAuthToken };

   this.common.authAppsSessions("GENMASTER", tokenObj).subscribe(
      (res) => {
      
      },
      (error) => {
        //console.error("error", error)
      }
    )}
 openResLink(url) {
    let studioUrl= `${url}?url=${window.location.origin}`;
    window.open(studioUrl, '_blank')
  }

  async getMetaInfo() {
    let apiRes:any = await this.common.getMetaJson();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map((r: any) => r.urlAfterRedirects),
        tap((route: string) => {
          if (Object.keys(apiRes).length > 0 && apiRes[route]) {
            this.meta.updateMetaWithApi(apiRes, route);
          }
          else {
            //  this.meta.updateMeta(route);
            this.meta.updateMetaWithApi(apiRes, route);
          }
        })).subscribe();
  }
  
}
